export default __webpack_public_path__ + "static/media/popup_lt.c0b1413b.png";